import { useTranslations } from "next-intl";
import useFeatures from "@hooks/use-features";
import Badge from "@components/core/Badge";
import badgeVariants from "@utils/constants/badgeVariants";
import catalogContexts from "@utils/constants/catalogContexts";

function CatalogProductStickers({ product, context }) {
  const t = useTranslations("catalog");

  const stickers = useFeatures()?.stickers;

  if (!product?.id || !stickers || stickers.length < 1 || context === catalogContexts.sales)
    return null;

  function displaySticker() {
    for (const sticker of stickers) {
      if (product.collections?.includes(sticker?.collection_slug)) {
        return (
          <Badge variant={badgeVariants[sticker.variant] || "light-primary"}>
            {t(`stickers.${sticker.sticker_key}`, sticker.sticker_name)}
          </Badge>
        );
      }
    }

    return null;
  }

  return <div className="catalog-product-stickers-container">{displaySticker()}</div>;
}

export default CatalogProductStickers;
